'use client';

import { Button } from '@components/ui/button';
import { cn } from '@utils/cn';
import { useTranslations } from 'next-intl';
import { FC } from 'react';

type ErrorStateProps = {
  title?: string;
  description?: string;
  /** Passed straight through from a Next.js error boundary. */
  reset?: () => void;
  className?: string;
};

const ErrorState: FC<ErrorStateProps> = ({
  title,
  description,
  reset,
  className
}) => {
  const t = useTranslations('error');

  return (
    <div
      role="alert"
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-xl px-6 py-16 text-center',
        'bg-card',
        className
      )}
    >
      <span aria-hidden className="size-1.5 rounded-full bg-status-danger" />
      <div className="space-y-1">
        <p className="text-card-title text-foreground">{title ?? t('title')}</p>
        <p className="mx-auto max-w-sm text-caption text-muted-foreground">
          {description ?? t('description')}
        </p>
      </div>
      {reset && (
        <Button variant="outline" size="sm" onClick={reset} className="mt-1">
          {t('retry')}
        </Button>
      )}
    </div>
  );
};

export default ErrorState;
